var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../elements/Basic");

var _Logos = require("../../Basic/Logos");

var _FontelloIcon = _interopRequireDefault(require("../../Basic/FontelloIcon"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Betting/Voting/TeamCard.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var TeamCard = function (_React$Component) {
  (0, _inherits2.default)(TeamCard, _React$Component);

  var _super = _createSuper(TeamCard);

  function TeamCard() {
    (0, _classCallCheck2.default)(this, TeamCard);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(TeamCard, [{
    key: "getCenterIcon",
    value: function getCenterIcon(src, iconSize) {
      return this.props.useFontelloIcons ? _react.default.createElement(_FontelloIcon.default, {
        color: "font.main",
        size: "custom",
        fontSize: iconSize || 44,
        name: "x",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 21,
          columnNumber: 13
        }
      }) : _react.default.createElement(_Logos.AssetLogo, {
        width: iconSize || 56,
        height: iconSize || 56,
        src: src,
        my: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23,
          columnNumber: 13
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          team = _this$props.team,
          isCenterCard = _this$props.isCenterCard,
          iconSize = _this$props.iconSize,
          minWidth = _this$props.minWidth;
      return _react.default.createElement(_Basic.Column, {
        isFlex: true,
        center: true,
        height: minWidth || 104,
        width: "100%",
        zIndex: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 31,
          columnNumber: 13
        }
      }, _react.default.createElement(_Basic.View, {
        height: iconSize || 56,
        bg: "transparent",
        my: iconSize ? 1 : 2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 32,
          columnNumber: 17
        }
      }, isCenterCard ? this.getCenterIcon(team.imageUrl) : _react.default.createElement(_Logos.TeamLogo, {
        size: iconSize || 56,
        src: team.imageUrl,
        my: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 25
        }
      })), _react.default.createElement(_Basic.Text, {
        px: 1,
        width: "100%",
        textWrap: true,
        numberOfLines: 1,
        center: true,
        mt: 1,
        height: 48,
        bold: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39,
          columnNumber: 17
        }
      }, team.label));
    }
  }]);
  return TeamCard;
}(_react.default.Component);

TeamCard.propTypes = {
  team: _propTypes.default.object.isRequired,
  isCenterCard: _propTypes.default.bool,
  useFontelloIcons: _propTypes.default.bool,
  minWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array])
};
TeamCard.defaultProps = {
  useFontelloIcons: true
};
var _default = TeamCard;
exports.default = _default;